// src/utils/acceptanceData.js
export const acceptanceData = {
    my: {
        title: "စာသင်သားလက်ခံချိန်",
        subtitle: "သီတင်းကျွတ်ချိန်အခါမှ ဝါဆိုသည်အထိ",
        sections: [
            {
                title: "လက်ခံချိန်",
                icon: "fas fa-calendar-alt",
                bullets: [
                    "ဝါတွင်းကာလမှတစ်ပါး မည်သည့်အချိန်မဆို ဝင်ရောက်နိုင်",
                    "ကျောင်းတိုက်စည်းကမ်း၊ ဝိနည်းစည်းကမ်းနှင့်အညီ နေနိုင်ရမည်"
                ]
            },
            {
                title: "သံဃာသစ်ဆောင်",
                icon: "fas fa-home",
                bullets: [
                    "သီးခြားကျောင်းဆောင်တွင် တစ်လတိတိ နေထိုင်ရမည်",
                    "သင်္ကန်းရုံနည်း၊ သပိတ်ကိုင်နည်း စသည်တို့ကို သင်ယူရမည်"
                ]
            },
            {
                title: "ဩဝါဒခံယူခြင်း",
                icon: "fas fa-book",
                bullets: [
                    "ညစဉ် ဩဝါဒနာယူရမည်",
                    "အသားကျမှသာ သံဃာအဟောင်းများနှင့်အတူ နေထိုင်ခွင့်ရမည်"
                ]
            }
        ]
    },
    en: {
        title: "Acceptance Season",
        subtitle: "From Thadingyut To Waso",
        sections: [
            {
                title: "Admission Period",
                icon: "fas fa-calendar-alt",
                bullets: [
                    "Open for admission throughout the year except during Buddhist Lent",
                    "Must follow monastery and Vinaya rules"
                ]
            },
            {
                title: "New Monks' Quarters",
                icon: "fas fa-home",
                bullets: [
                    "One month minimum stay in separate quarters",
                    "Learn proper monastic practices and etiquette"
                ]
            },
            {
                title: "Daily Guidance",
                icon: "fas fa-book",
                bullets: [
                    "Receive nightly instruction and guidance",
                    "Move to regular quarters after proper adjustment"
                ]
            }
        ]
    }
};